module.exports = __webpack_public_path__ + "img/hyjs.e3803b75.png";